import * as yup from 'yup';

import { RolesEnum } from 'types/user';

export const initialValues = {
  fname: '',
  lname: '',
  role: '',
  phone: '',
  email: '',
  washHub: '',
};

export const rolesMap: Record<string, string> = {
  [RolesEnum.ADMIN]: 'Admin',
  [RolesEnum.SUPER_ADMIN]: 'Super Admin',
  [RolesEnum.WASH_HUB_ADMIN]: 'Wash Hub Admin',
  [RolesEnum.WASH_HUB_STAFF]: 'Wash Hub Staff',
  // [RolesEnum.CUSTOMER]: 'Customer',
};

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const validationSchema = yup.object().shape({
  fname: yup.string().min(3).required('First name is required field'),
  lname: yup.string().min(3).required('Last name is required field'),
  email: yup.string().email().required(),
  role: yup.string().required('Role name is required field'),
  phone: yup.string().matches(phoneRegExp, 'Phone number is not valid'),
  washHub: yup.string(),
});
